import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Col,  CardBody } from 'reactstrap';
import { Field, reduxForm } from 'redux-form';
import { DatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import MenuItem from '@material-ui/core/MenuItem';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import moment from 'moment';
import MomentUtils from '@date-io/moment';
import DataReactTable from './DataReactTable';
import Button from '@material-ui/core/Button';
import SearchIcon from '@material-ui/icons/Search';
import history from '../../../../../history';

const renderField = ({
    input, disabled, placeholder, type, meta: { touched, error }, style
  }) => (
    <div className="form__form-group-input-wrap form__form-group-input-wrap--error-above" style={style}>
      <input {...input} placeholder={placeholder} type={type} disabled={disabled}/>
      {touched && error && <span className="form__form-group-error">{error}</span>}
    </div>
  );
  
  renderField.propTypes = {
    input: PropTypes.shape().isRequired,
    placeholder: PropTypes.string,
    type: PropTypes.string,
    meta: PropTypes.shape({
      touched: PropTypes.bool,
      error: PropTypes.string,
    }),
  };
  
  renderField.defaultProps = {
    placeholder: '',
    meta: null,
    type: 'text',
};

class SearchDebitNotes extends Component {
	constructor(props){
        super(props);
        this.state = {
          numberBilling: "",
          documentNumber: "",
          dates: { start: new Date(), end: new Date() },
          costumer: "",
          costumers: [],
          debitNote: [],
          load: true,
        }
	}
	
	componentDidMount(){
        if(history.location.state !== this.state){
            console.log(history.location);
            this.setState({load: true}, () => {
                this.setState({ ...history.location.state, load: false }, ()=>{
                    //this.loadCostumer();
                });
            })
            
        } else {
            history.replace({ state: this.state });
        }
        this.loadCostumer();
    }

    loadCostumer = () => {
        fetch( process.env.REACT_APP_PUBLIC_URL + 'tercero/listar',  {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'), 
            }
          })
          .then(response => {
            return response.json();
          })
          .then(data => {
            console.log(data);
            this.setState({ costumers: data });
          })
          .catch((error) => {
            console.error('Error:', error);
          });
    }

    searchDebitNote = () => {
      var data = null;

      if( this.state.numberBilling !== ""){
         data =  {
          num_fact: this.state.numberBilling !== ""? "NC-" + this.state.numberBilling: "", 
          tipo_cliente: "",
          id: "",
          desde: "",
          hasta: ""
        };
      } else {
        data =  {
          num_fact: "", 
          tipo_cliente: this.state.costumer === 0? "Paciente": "Tercero",
          id: this.state.numberBilling === "" ? (this.state.costumer === 0 ? parseInt(this.state.documentNumber): this.state.costumer): "",
          desde: moment(this.state.dates.start).format("YYYY-MM-DD"),
          hasta: moment(this.state.dates.end).format("YYYY-MM-DD")
        };
      }

      console.log(data);
      this.setState({load: true } , ()=> {
        fetch( process.env.REACT_APP_PUBLIC_URL + 'facturas/consultarndebito',  {
          method: 'POST',
          headers: {
              'Content-Type': 'application/json',
              'authorization': 'Bearer ' + sessionStorage.getItem('token'), 
          },
          body: JSON.stringify(data)
        })
        .then(response => {
          return response.json();
        })
        .then(data => {
          
          
  
          if(data.existe){
            var notes = data.contenido.map((note)=> {
              note.fecha_emision = moment(note.fecha_emision).format("YYYY-MM-DD HH:MM a");
              return note;
            })
            
            this.setState({ debitNote: notes, load: false });
            var stateOld = this.state;
            stateOld.dates.start =  moment(stateOld.dates.start).toString();
            stateOld.dates.start =  moment(stateOld.dates.end).toString();
            console.log()
            history.replace({ state: stateOld });
          } else {
            alert(data.contenido)
            this.setState({ debitNote: [], load: false });
            var stateOld = this.state;
            stateOld.dates.start =  moment(stateOld.dates.start).toString();
            stateOld.dates.start =  moment(stateOld.dates.end).toString();
            history.replace({ state: stateOld });
            
          }
        }).catch((e)=>{
          console.log(e);
          this.setState({ load: false });
        });
      })
      
    }


render(){
    const reactTableData = { 
        tableHeaderData: [{
            Header: 'id',
            accessor: 'id_notad',
            disableGlobalFilter: true,
            width: 65
          },
          {
            Header: 'Nota N°',
            accessor: 'num_notad'
          },
          {
            Header: 'Factura N°',
            accessor: 'num_fact'
          },
          {
            Header: 'Fecha',
            accessor: 'fecha_emision'
          },
          {
            Header: 'NIT',
            accessor: 'nit'
          },
          {
            Header: 'Cliente',
            accessor: 'cliente'
          },
          {
            Header: 'Observación',
            accessor: 'observaciones'
          },
          {
            Header: 'Valor',
            accessor: 'monto'
          }
        ], 
          tableRowsData: this.state.debitNote };
		  
	return (<CardBody>
            <Col>
              <div style={{ display: 'flex', width: '50%' }}>
                  <FormControl style={{ width: '100%' }} >
                      <InputLabel required id="demo-simple-select-label" >Cliente</InputLabel>
                      <Select
                          labelId="demo-simple-select-label"
                          id="id-simple-select"
                          value={this.state.costumer}
                          onChange={ e => this.setState({ costumer :e.target.value})}
                          style={{ width: '100%' }}
                      >
                              <MenuItem key={0} value={0}>Paciente</MenuItem>
                          {this.state.costumers.map(costumer=>{
                              return <MenuItem key={costumer.id_tercero} value={costumer.id_tercero}>{costumer.nombre}</MenuItem>
                          })}
                      </Select>
                  </FormControl>
                </div>
                <div className="form" style={{ display: 'flex', flexDirection: 'row', flexWrap: 'nowrap' }}>
                    <div className="form__form-group" style={{ marginRight: 5 }}>
                            <span className="form__form-group-label">N° Factura</span>
                            <div className="form__form-group-field">
                                <Field
                                    key={`number-invoice`}
                                    name={`number-invoice`}
                                    component={renderField}
                                    type="number"
                                    placeholder={''}
                                    value={this.state.numberBilling}
                                    onChange={ e => this.setState({ numberBilling :e.target.value})}
                                />
                            </div>
                        </div>
                        <div className="form__form-group">
                            <span className="form__form-group-label">N° documento</span>
                            <div className="form__form-group-field">
                                <Field
                                    key={`number-note`}
                                    name={`number-note`}
                                    component={renderField}
                                    type="number"
                                    placeholder={''}
                                    value={this.state.documentNumber}
                                    onChange={(e) => {
                                        this.setState({ documentNumber: e.target.value});
                                    }}
                                    disabled={this.state.costumer !== 0}
                                />
                            </div>
                        </div>
                    </div>
            </Col>
            <Col style={{ display: 'flex' }}>
                <div style={{ paddingRight: 5, width: '50%', display: 'flex' }}>
                    <MuiPickersUtilsProvider utils={MomentUtils}>
                        <DatePicker
                            disableFuture
                            openTo="year"
                            label="Fecha desde"
                            views={["year", "month", "date"]}
                            value={this.state.dates.start}
                            onChange={(date)=>{
                                this.setState({ dates: {...this.state.dates, start: date }});
                            }}
                            animateYearScrolling
                            format="yyyy/MM/D"
                            style={{ marginRight: 10, width: '100%' }}
                        />
                        <DatePicker
                            disableFuture
                            openTo="year"
                            label="Fecha hasta"
                            views={["year", "month", "date"]}
                            value={this.state.dates.end}
                            onChange={(date)=>{
                                this.setState({ dates: {...this.state.dates, end: date }});
                            }}
                            animateYearScrolling
                            format="yyyy/MM/D"
                            style={{ width: '100%' }}
                        />
                    </MuiPickersUtilsProvider>
                   
                </div>
                
            </Col>
            <Col>           
                
            </Col>
            <Col>
                <div style={{ marginTop: 20 }}>
                    <Button 
                        style={{ }}
                        variant="contained" 
                        color="primary" 
                        onClick={() => {
                          this.searchDebitNote();
                        }}
                    >
                        <SearchIcon />
                    </Button>
                    <Button 
                        style={{ marginLeft: 20 }}
                        variant="contained" 
                        color="primary" 
                        onClick={() => {
                            history.push({
                                pathname: process.env.PUBLIC_URL +'/billing/add-debit-notes',
                                state: { numNota: 0 } 
                              });
                        }}
                    >
                        Agregar Nota Debito
                    </Button>
                </div>
            </Col>
            <Col>
            { !this.state.load? <DataReactTable title={'Notas Debito'} reactTableData={reactTableData} />: null}
            </Col>
        </CardBody>)
      }
}
export default  reduxForm({
    form: 'search_cretit_note_form', // a unique identifier for this form
})(SearchDebitNotes);